import { IconTypes, UI } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import * as NB from 'native-base';
import React from 'react';

interface ProductIconListProps {
  icons: IconographyTypes.Option[];
  isTooltip?: boolean;
  size?: IconTypes.Sizes;
}

interface ProductIconProps {
  name: IconographyTypes.Option;
  size?: IconTypes.Sizes;
}

const label = {
  QualifiedClient: {
    title: 'Investidor qualificado',
    iconColor: Color['brand.secondary.principal'],
  },
  Liquidity: { title: 'Liquidez diária', iconColor: Color['brand.primary.principal'] },
  IncomeTaxExempt: { title: 'Isento de IR', iconColor: Color['brand.tertiary.dark'] },
  Fgc: { title: 'Garantia pelo FGC', iconColor: Color['feedback.success.default'] },
  Locked: { title: 'Fundo fechado', iconColor: Color['brand.tertiary.light'] },
  ProfessionalInvestor: {
    title: 'Investidor profissional',
    iconColor: Color['brand.tertiary.principal'],
  },
} as const;

const ProductIcon = ({ name, size }: ProductIconProps) => {
  return (
    <NB.Box
      bg="neutral.white"
      borderRadius="full"
      p={'2px'}
      justifyContent="center"
      alignItems="center">
      <UI.Icon
        testId="qa"
        name={name}
        size={size || 'xxxxs'}
        color={label[name].iconColor || label.IncomeTaxExempt.iconColor}
      />
    </NB.Box>
  );
};

const ProductNameIcon = ({ name, size }: ProductIconProps) => {
  return (
    <UI.Tooltip testId="qa" label={label[name].title || 'Erro ao identificar nome'}>
      <NB.Box
        bg="neutral.white"
        borderRadius="full"
        p={'2px'}
        justifyContent="center"
        alignItems="center">
        <ProductIcon name={name} size={size} />
      </NB.Box>
    </UI.Tooltip>
  );
};

export const IconProductList = ({ icons, isTooltip, size }: ProductIconListProps) => {
  const IconComponent = isTooltip ? ProductNameIcon : ProductIcon;

  return (
    <NB.HStack space={'4px'} testID="product-legend">
      {icons.map((icon) => (
        <UI.Shadow level={1} testId="qa" borderRadius="full" key={icon}>
          <IconComponent name={icon} size={size} />
        </UI.Shadow>
      ))}
    </NB.HStack>
  );
};
